"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const workflowContext_1 = require("../../../../../utils/workflowContext");
const ui_1 = require("../../../../ui");
const groupWidget_style_1 = __importDefault(require("./groupWidget.style"));
const GroupWidget = ({ classes, label = '', value = '', formContext }) => {
    const selectedGroup = workflowContext_1.getSelectedGroupDetails(formContext.workflowContext, value);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.label }, { children: label }), void 0),
            jsx_runtime_1.jsx("div", Object.assign({ className: classes.value }, { children: selectedGroup ? (jsx_runtime_1.jsx(ui_1.WorkflowGroup, { name: selectedGroup.name || value, avatar: selectedGroup.avatar }, void 0)) : (value) }), void 0)] }, void 0));
};
exports.GroupWidget = GroupWidget;
exports.default = react_jss_1.default(groupWidget_style_1.default)(exports.GroupWidget);
//# sourceMappingURL=index.js.map